class AnnouncementBarMarquee extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const wrapper = this.children[0];
    if (wrapper.dataset.cloned) return;
    wrapper.dataset.cloned = true;

    const content = wrapper.querySelectorAll('.announcement-bar-marquee__content');
    const contentWidth = wrapper.offsetWidth + parseInt(getComputedStyle(wrapper).gap);
    const maxContentWidth = Math.max(window.screen.width, window.screen.height);
    const repeatCount = (Math.ceil(maxContentWidth / contentWidth) + 1) * content.length;

    for (let i = 0; i < repeatCount; ++i) {
      const clone = content[i % content.length].cloneNode(true);
      wrapper.appendChild(clone);
    }

    wrapper.style.setProperty('--marquee-content-width', `-${contentWidth}px`);
    this.classList.add('active');
  }
}

customElements.define('announcement-bar-marquee', AnnouncementBarMarquee);
